import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const SalesTemplatesLazy = lazy(() =>
  import("./SalesTemplates").then((module) => ({ default: module.SalesTemplates })),
);

export const SalesTemplatesAsync = () => (
  <Suspense fallback={<LoadingIndicatorFullPage open />}>
    <SalesTemplatesLazy />
  </Suspense>
);
